import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { getEventTrackerQuery } from '@shared/services/gql.service';

export type EventStoreState = EntityState<getEventTrackerQuery & { _id: string }>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ idKey: '_id', name: 'events' })
export class EventStore extends EntityStore<EventStoreState> {
  constructor() {
    super({});
  }
}
